import { DESKTOP } from 'chemistry'

const PRODUCT_CODE_MAX_LENGTH = 18
export const PRODUCT_CODE_MIN_LENGTH = 7
export const BRICO = 'brico'
export const isBrico = format => format === BRICO

export const replaceInTranslation = (translation, replace = false) => {
  if (!replace) return translation
  Object.keys(replace).forEach(key => {
    const value = replace[key]
    const occ = new RegExp('{' + key + '}', 'g')
    if (translation) {
      translation = translation.replace(occ, value)
    }
  })
  return translation
}

export const leftPad = (number, length, character) => {
  character = character || '0'

  let myString = '' + number
  while (myString.length < length) {
    myString = character + myString
  }

  return myString
}

export const properProductCode = (code, full) => {
  let productCode = code && code.replace(/^0+/, '')

  if (productCode && productCode.length < PRODUCT_CODE_MIN_LENGTH) {
    productCode = leftPad(productCode, PRODUCT_CODE_MIN_LENGTH)
  }

  if (!full) return productCode
  return leftPad(productCode, PRODUCT_CODE_MAX_LENGTH)
}

export function getLocale(format, language) {
  if (isBrico(format)) {
    if (language === 'nl' || language === 'nl_BE') {
      return 'nl_BE'
    } else {
      return 'fr_BE'
    }
  }
  return 'nl_NL'
}

export const removeSpecialChars = term => term.replace(/[^0-9a-zA-Z:,\s]+/g, '')

export const getJumperId = ({ addToPageJumper, shortTitlePageJumper }) => {
  if (!addToPageJumper) return false
  if (!shortTitlePageJumper) return false
  return shortTitlePageJumper
    .replace(/ /g, '-')
    .toLowerCase()
    .replace(/[^a-zàâçéèêëîïôûùüÿñæœ0-9\-_]/g, '')
}

export const getProductPosition = (position, page, perPage) => perPage * Math.max(page - 1, 0) + position

export const applyContainerSx = (props, data) => {
  props.sx = {
    ...props.sx
  }
  const { maxWidth } = data
  if (maxWidth) {
    props.sx = {
      ...props.sx,
      [DESKTOP]: {
        maxWidth: `${maxWidth}px`
      }
    }
  }
  return {
    ...props
  }
}

export const extractFnBody = fn => {
  const str = fn.toString()
  // Handle arrow functions: () => { ... }
  const arrowMatch = str.match(/^[\s\S]*?=>\s*[{]([\s\S]*)[}]\s*$/)
  if (arrowMatch) return arrowMatch[1]
  // Handle regular functions: function(...) { ... }
  const funcMatch = str.match(/^function[^{]*[{]([\s\S]*)[}]\s*$/)
  if (funcMatch) return funcMatch[1]
  return str
}

export const isNullOrUndefined = v => v === null || v === undefined

export const isEmptyObject = obj => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false
    }
  }
  return true
}

export const getAlgoliaIndex = () => {
  const format = window.location.host.includes('praxis') ? 'praxis' : 'brico'
  const env = window.location.host.includes('acc') ? 'acc' : 'prd'
  let index = `${env}_brico_products_nl_be`
  if (format === 'praxis') index = `${env}_praxis_products_nl_nl`
  else if (window.location.pathname.includes('/fr/')) index = `${env}_brico_products_fr_be`
  return index
}

export function algoliaCallWhenReady(...args) {
  const [event, payload, i = 6] = args
  if (!window.aa && i > 0) {
    setTimeout(() => {
      algoliaCallWhenReady(event, payload, i - 1)
    }, 1000)
  } else {
    return window.aa?.(event, payload)
  }
}

let collectionIdsHashLatest = null

export const algoliaListerItemViewedCallWhenReady = collectionIds => {
  const collectionIdsHash = JSON.stringify(collectionIds)
  if (collectionIdsHashLatest !== collectionIdsHash) {
    collectionIdsHashLatest = collectionIdsHash
    chunkArray(collectionIds, 20).forEach(chunk =>
      algoliaCallWhenReady('viewedObjectIDs', {
        eventName: 'Item Viewed',
        index: getAlgoliaIndex(),
        objectIDs: chunk
      })
    )
  }
}

export const ALGOLIA_QUERY_ID_AND_PRODUCT_ID_RELATIONS_KEY = 'ALGOLIA_QUERY_ID_AND_PRODUCT_ID_RELATIONS_KEY'
export const ALGOLIA_QUEUE_PRODUCT_IDS = 'ALGOLIA_QUEUE_PRODUCT_IDS'
export const storeQueryIdAndProductIdRelation = (
  { productId, queryID, index },
  { skipQueue } = { skipQueue: false }
) => {
  if (!window.aa) return
  if (!productId || !queryID) return

  const position = index + 1

  const relationsList = JSON.parse(localStorage.getItem(ALGOLIA_QUERY_ID_AND_PRODUCT_ID_RELATIONS_KEY) || '[]')
  let existedRelationsItemQueryIDs = []
  let existedRelationsItemPositions = []
  const newRelationsList = relationsList.filter(
    ({ productId: relationsItemProductId, queryIDs: relationsItemQueryIDs, positions: relationsItemPositions }) => {
      if (relationsItemProductId === productId) {
        existedRelationsItemQueryIDs = relationsItemQueryIDs
        existedRelationsItemPositions = relationsItemPositions
        return false
      }
      return true
    }
  )
  newRelationsList.unshift({
    productId,
    queryIDs: [
      queryID,
      ...existedRelationsItemQueryIDs.filter(existedRelationsItemQueryID => existedRelationsItemQueryID !== queryID)
    ],
    positions: [
      position,
      ...existedRelationsItemPositions.filter(existedRelationsItemPosition => existedRelationsItemPosition !== position)
    ]
  })
  localStorage.setItem(ALGOLIA_QUERY_ID_AND_PRODUCT_ID_RELATIONS_KEY, JSON.stringify(newRelationsList.slice(0, 30)))

  if (!skipQueue) {
    const productIds = JSON.parse(localStorage.getItem(ALGOLIA_QUEUE_PRODUCT_IDS) || '[]')
    if (productIds[0] !== productId) {
      productIds.unshift(productId)
      localStorage.setItem(ALGOLIA_QUEUE_PRODUCT_IDS, JSON.stringify(productIds.slice(0, 30)))
    }
  }
}

export function chunkArray(array, chunkSize) {
  const results = []

  for (let i = 0; i < array.length; i += chunkSize) {
    results.push(array.slice(i, i + chunkSize))
  }

  return results
}
